<style>
.user table  tr th{
  text-align: center;
}
.user table  td:nth-child(1){
  text-align: center;
}
</style>
<template>
  <div class="dynamic-tables">
    <Widget title="<h4>User</h4>" collapse close customHeader>
      <div class="form-group row">
        <div class="col-sm-6">
          <b-button variant="success" v-b-modal.modal-tambah><span class="glyphicon glyphicon-plus mb-2" /> Tambah
          </b-button>
        </div>
        <div class="col-sm-6 text-end">
        </div>
      </div>
      <div class="user">
        <v-client-table :data="itemsWithNumber" :columns="columnsDatatable" :options="optionsUsers">
          <div slot="aksi" slot-scope="props">
            <b-button variant="info" class="me-3" size="s" @click="getDetail(props.row.id)">
              <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white">Edit</span>
            </b-button>
            <b-button variant="warning" class="me-3" size="s" @click="getDetailPassword(props.row.id)">
              <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white">Edit Password</span>
            </b-button>
            <b-button style="margin-left:5px" class="me-3" size="s" variant="danger" @click="deleteData(props.row.id)">
              <i class="glyphicon glyphicon-trash text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white">Delete</span>
            </b-button>

          </div>
        </v-client-table>
      </div>
    </Widget>

    <!-- modal tambah -->
    <b-modal @hidden="onHiddenModalUser" body-class="bg-white" id="modal-tambah" scrollable title="Tambah User" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary" size="lg">
      <form ref="form">
        <b-row class="g-4">
          <b-col md="6">
            <b-form-group label="Nama" label-for="name" class="mb-3">
              <b-form-input v-validate="'required'" name="Nama"
                :class="{ 'form-control': true, 'is-invalid': errors.has('Nama') }" id="name"
                v-model="dataPengguna.nama" />
              <span class="text-danger" v-if="errors.has('Nama')">
                {{ errors.first('Nama') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Email" label-for="email" class="mb-3">
              <b-form-input v-validate="'required|email'" name="Email"
                :class="{ 'form-control': true, 'is-invalid': errors.has('Email') }" id="email"
                v-model="dataPengguna.email" type="email" autocomplete="off" />
              <span class="text-danger" v-if="errors.has('Email')">
                {{ errors.first('Email') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Password" label-for="password" class="mb-3">
              <b-form-input id="password" v-model="dataPengguna.password" type="password" v-validate="'required'"
                name="Password" :class="{ 'form-control': true, 'is-invalid': errors.has('Password') }" autocomplete="new-password" />
              <span class="text-danger" v-if="errors.has('Password')">
                {{ errors.first('Password') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Role" label-for="role">
              <v-select id="role" v-model="dataPengguna.roles" :options="dataRoleOptions" multiple
                v-validate="'required'" name="Role"
                :class="{ 'is-invalid': errors.has('Role') }" />
              <span class="text-danger" v-if="errors.has('Role')">
                {{ errors.first('Role') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Jabatan" label-for="jabatan">
              <v-select id="jabatan" v-model="dataPengguna.jabatan" :options="dataJabatanOptions"
                v-validate="'required'" name="Jabatan"
                :class="{ 'is-invalid': errors.has('Jabatan') }" />
              <span class="text-danger" v-if="errors.has('Jabatan')">
                {{ errors.first('Jabatan') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="NIP" label-for="nip" class="mb-3">
              <b-form-input v-validate="'required'" name="NIP"
                :class="{ 'form-control': true, 'is-invalid': errors.has('NIP') }" id="nip"
                v-model="dataPengguna.nip"/>
              <span class="text-danger" v-if="errors.has('NIP')">
                {{ errors.first('NIP') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Golongan" label-for="golongan" class="mb-3">
              <b-form-input v-validate="'required'" name="Golongan"
                :class="{ 'form-control': true, 'is-invalid': errors.has('Golongan') }" id="golongan"
                v-model="dataPengguna.golongan"/>
              <span class="text-danger" v-if="errors.has('Golongan')">
                {{ errors.first('Golongan') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="No HP" label-for="no_hp" class="mb-3">
              <b-form-input v-validate="'required'" name="No HP"
                :class="{ 'form-control': true, 'is-invalid': errors.has('No HP') }" id="no_hp"
                v-model="dataPengguna.no_hp" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
              <span class="text-danger" v-if="errors.has('No HP')">
                {{ errors.first('No HP') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Wilayah" label-for="upt" class="mb-3">
              <v-select v-validate="'required'" name="Wilayah"
                id="upt" v-model="dataPengguna.id_upt" :options="dataUpt" :reduce="d => d.id" label="nama_daerah" />
              <span class="text-danger" v-if="errors.has('Wilayah')">
                {{ errors.first('Wilayah') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Alamat" label-for="alamat" class="mb-3">
              <b-form-textarea name="Alamat" :class="{ 'form-control': true, 'is-invalid': errors.has('Alamat') }"
                id="alamat" v-model="dataPengguna.alamat" placeholder="Enter something..." rows="3" max-rows="6"
                v-validate="'required'"></b-form-textarea>
              <span class="text-danger" v-if="errors.has('Alamat')">
                {{ errors.first('Alamat') }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="onSubmit">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal edit -->
    <b-modal @hidden="onHiddenModalUser" body-class="bg-white" id="modal-edit" scrollable title="Edit User" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary" size="lg">
      <form ref="form">
        <b-row class="g-4">
          <b-col md="6">
            <b-form-group label="Nama" label-for="name" class="mb-3">
              <b-form-input v-validate="'required'" name="Nama"
                :class="{ 'form-control': true, 'is-invalid': errors.has('Nama') }" id="name"
                v-model="dataPengguna.nama" />
              <span class="text-danger" v-if="errors.has('Nama')">
                {{ errors.first('Nama') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Email" label-for="email" class="mb-3">
              <b-form-input v-validate="'required|email'" name="Email"
                :class="{ 'form-control': true, 'is-invalid': errors.has('Email') }" id="email"
                v-model="dataPengguna.email" type="email" autocomplete="off" />
              <span class="text-danger" v-if="errors.has('Email')">
                {{ errors.first('Email') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Role" label-for="role">
              <v-select id="role" v-model="dataPengguna.roles" :options="dataRoleOptions" multiple
                v-validate="'required'" name="Role"
                :class="{ 'is-invalid': errors.has('Role') }" />
              <span class="text-danger" v-if="errors.has('Role')">
                {{ errors.first('Role') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Jabatan" label-for="jabatan">
              <v-select id="jabatan" v-model="dataPengguna.jabatan" :options="dataJabatanOptions"
                v-validate="'required'" name="Jabatan"
                :class="{ 'is-invalid': errors.has('Jabatan') }" />
              <span class="text-danger" v-if="errors.has('Jabatan')">
                {{ errors.first('Jabatan') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="NIP" label-for="nip" class="mb-3">
              <b-form-input v-validate="'required'" name="NIP"
                :class="{ 'form-control': true, 'is-invalid': errors.has('NIP') }" id="nip"
                v-model="dataPengguna.nip"/>
              <span class="text-danger" v-if="errors.has('NIP')">
                {{ errors.first('NIP') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Golongan" label-for="golongan" class="mb-3">
              <b-form-input v-validate="'required'" name="Golongan"
                :class="{ 'form-control': true, 'is-invalid': errors.has('Golongan') }" id="golongan"
                v-model="dataPengguna.golongan"/>
              <span class="text-danger" v-if="errors.has('Golongan')">
                {{ errors.first('Golongan') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="No HP" label-for="no_hp" class="mb-3">
              <b-form-input v-validate="'required'" name="No HP"
                :class="{ 'form-control': true, 'is-invalid': errors.has('No HP') }" id="no_hp"
                v-model="dataPengguna.no_hp" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
              <span class="text-danger" v-if="errors.has('No HP')">
                {{ errors.first('No HP') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Wilayah" label-for="upt" class="mb-3">
              <v-select name="Wilayah" v-validate="'required'"  
                id="upt" v-model="dataPengguna.id_upt" :options="dataUpt" :reduce="d => d.id" label="nama_daerah" />
                <span class="text-danger" v-if="errors.has('Wilayah')">
                {{ errors.first('Wilayah') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Alamat" label-for="alamat" class="mb-3">
              <b-form-textarea name="Alamat" :class="{ 'form-control': true, 'is-invalid': errors.has('alamat') }"
                id="alamat" v-model="dataPengguna.alamat" placeholder="Enter something..." rows="3" max-rows="6"
                v-validate="'required'"></b-form-textarea>
              <span class="text-danger" v-if="errors.has('Alamat')">
                {{ errors.first('Alamat') }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="editData(dataPengguna.id)">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal Ubah Password -->
    <b-modal @hidden="onHiddenModalUser" body-class="bg-white" id="modal-edit-password" title="Edit Password" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary" size="md">
      <form ref="form" @submit.stop.prevent="ubah_password">
        <b-row>
          <b-col md="6">
            <b-form-group label="Nama" label-for="name" class="mb-3">
              <b-form-input disabled v-validate="'required'" name="Nama"
                :class="{ 'form-control': true, 'is-invalid': errors.has('Nama') }" id="name"
                v-model="dataPengguna.nama" />
              <span class="text-danger" v-if="errors.has('Nama')">
                {{ errors.first('Nama') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Email" label-for="email" class="mb-3">
              <b-form-input disabled d v-validate="'required|email'" name="Email"
                :class="{ 'form-control': true, 'is-invalid': errors.has('Email') }" id="email"
                v-model="dataPengguna.email" type="email" />
              <span class="text-danger" v-if="errors.has('Email')">
                {{ errors.first('Email') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Password Baru" label-for="password" class="mb-3">
              <b-form-input v-validate="'required'" name="Password"
                :class="{ 'form-control': true, 'is-invalid': errors.has('Password') }" id="password"
                v-model="new_password"/>
              <span class="text-danger" v-if="errors.has('Password')">
                {{ errors.first('Password') }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="editPassword(dataPengguna.id)">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
  
<script>
import Widget from '@/components/Widget/Widget';
import axios from 'axios';
import Swal from 'sweetalert2'
import { Validator } from 'vee-validate';
import vSelect from 'vue-select';

export default {
  name: 'Dynamic',
  components: { Widget, vSelect },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem("baseapiPengendalian"),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      columnsDatatable: ['no','nama', 'email', 'role', 'aksi'],
      dataUser: [],
      dataPengguna: {
        nama: '',
        email: '',
        password: '',
        roles: [],
        jabatan: '',
        nip: '',
        golongan: '',
        no_hp: '',
        id_upt: '',
        alamat: '',
      },
      dataRole: [],
      optionsUsers: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        columnsClasses: { no: 'width-100' },
        skin: 'table table-striped',
        sortIcon: {
          base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
        },
      },
      dataJabatan: [],
      dataProvinsi: [],
      dataUpt: [],
      new_password: null
    };
  },
  computed: {
    itemsWithNumber() {
      return this.dataUser.map((d, index) => ({ ...d, no: index + 1 }))
    },
    dataRoleOptions() {
      return this.dataRole.map(r => r.name);
    },
    dataJabatanOptions() {
      return this.dataJabatan.map(j => j.nama_jabatan);
    }
  },
  mounted() {
    this.loaddata()
    this.getRole()
    this.getJabatan()
    this.getProvinsi()
    this.getUpt()
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: () => 'Email tidak valid',
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
    
  },
  methods: {
    deleteData(id) {
      Swal.fire({
        title: 'Hapus Data?',
        // text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya'
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(
              this.baseapiPengendalian + `api/user/` + id,
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken
                }
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Dihapus");
              this.loaddata()
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },
    async onSubmit() {
      await this.$validator.validateAll();
      if (this.$validator.errors.any()) return
      
      const nama_upt = (this.dataUpt.find((d) => d.id == this.dataPengguna.id_upt)).nama_daerah
      await axios
        .post(this.baseapiPengendalian + 'api/user', {
          nama: this.dataPengguna.nama,
          email: this.dataPengguna.email,
          password: this.dataPengguna.password,
          roles: this.dataPengguna.roles,
          role: this.dataPengguna.roles[0] || '',
          jabatan: this.dataPengguna.jabatan,
          nip: this.dataPengguna.nip,
          golongan: this.dataPengguna.golongan,
          no_hp: this.dataPengguna.no_hp,
          id_upt: this.dataPengguna.id_upt,
          nama_upt: nama_upt,
          alamat: this.dataPengguna.alamat,
        }, this.apiOption())
        .then((res) => {
          this.$toasted.success("Berhasil Ditambah");
          this.loaddata()
          this.dataPengguna = []
          return res;
        })
        .catch((err) => {
          console.log(err)
          this.$toasted.error(err.response.data.message);
          return err;
        });

      this.$nextTick(() => {
        this.$bvModal.hide('modal-tambah')
      });
    },

    async editData(id) {
      await this.$validator.validateAll();
      if (this.$validator.errors.any()) return

      const nama_upt = (this.dataUpt.find((d) => d.id == this.dataPengguna.id_upt)).nama_daerah
      await axios
        .put(this.baseapiPengendalian + 'api/user/'+ id, {
          nama: this.dataPengguna.nama,
          email: this.dataPengguna.email,
          roles: this.dataPengguna.roles,
          role: this.dataPengguna.roles[0] || '',
          jabatan: this.dataPengguna.jabatan,
          nip: this.dataPengguna.nip,
          golongan: this.dataPengguna.golongan,
          no_hp: this.dataPengguna.no_hp,
          id_upt: this.dataPengguna.id_upt,
          nama_upt: nama_upt,
          alamat: this.dataPengguna.alamat,
        }, this.apiOption())
        .then((res) => {
          this.$toasted.success("Berhasil Dubah");
          this.loaddata()
          this.dataPengguna = []
          return res;
        })
        .catch((err) => {
          console.log(err)
          this.$toasted.error(err.response.data.message);
          return err;
        });

      this.$nextTick(() => {
        this.$bvModal.hide('modal-edit')
      });
    },
    async editPassword(id) {
      await this.$validator.validateAll();
      if (this.$validator.errors.any()) return

      axios
        .put(this.baseapiPengendalian + 'api/user/'+ id, {
          password: this.new_password,
        },{
          headers: {
            Authorization: `Bearer ` + this.user.accessToken
          }
        })
        .then((res) => {
          this.$toasted.success("Berhasil Dubah");
          this.loaddata()
          this.dataPengguna = []
          this.new_password = null
          return res;
        })
        .catch((err) => {
          console.log(err)
          this.$toasted.error(err.response.data.message);
          return err;
        });

      this.$nextTick(() => {
        this.$bvModal.hide('modal-edit-password')
      });
    },

    getRole() {
      axios.get(this.baseapiPengendalian + "api/role?limit=0", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataRole = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    getJabatan() {
      axios.get(this.baseapiPengendalian + "api/jabatan?limit=0", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataJabatan = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    getProvinsi() {
      axios.get(this.baseapiPengendalian + "api/provinsi?limit=0", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataProvinsi = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    getUpt() {
      axios.get(this.baseapiPengendalian + "api/upt?limit=0", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataUpt = response.data.data.filter((d) => {
          const upt = ['PUSAT', 'PAPUA BARAT', 'SULAWESI SELATAN', 'SUMATERA BARAT', 'BANTEN']
          return upt.includes(d.nama_daerah)
        });
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // loaddata user
    loaddata() {
      axios.get(this.baseapiPengendalian + "api/user?limit=0", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataUser = response.data.data.map(d => ({
          ...d,
          role: d.roles?.length ? d.roles.join(', ') : d.role
        }))
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // detail
    getDetail(id) {
      axios.get(this.baseapiPengendalian + "api/user/" + id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataPengguna = response.data.data;
        if (Array.isArray(this.dataPengguna.roles)) {
        } else if (this.dataPengguna.role) {
          this.dataPengguna.roles = [this.dataPengguna.role];
        } else {
          this.dataPengguna.roles = [];
        }
        this.$nextTick(() => {
          this.$bvModal.show('modal-edit')
        });
      }).catch(error => {
        console.log(error)
        return error
      });
    },
    getDetailPassword(id) {
      axios.get(this.baseapiPengendalian + "api/user/" + id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataPengguna = response.data.data;
        this.$nextTick(() => {
          this.$bvModal.show('modal-edit-password')
        });
      }).catch(error => {
        console.log(error)
        return error
      });
    },
    apiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }
    },
    onHiddenModalUser(e) {
      for (const d in this.dataPengguna) {
        this.dataPengguna[d] = ''
      }
      this.dataPengguna.roles = [];
    }
  },
};
</script>
  
  

<style src="./User.scss" lang="scss" />
  